import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  alpha,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InquiryForm from './InquiryForm';

const InquiryPopup = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      fullScreen={false}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: alpha('#000', 0.5),
          },
        },
      }}
      sx={{
        '& .MuiDialog-container': {
          alignItems: 'center',
        },
      }}
      PaperProps={{
        sx: {
          borderRadius: { xs: 3, sm: 3 },
          overflow: 'visible',
          m: { xs: 0, sm: 2 },
          maxHeight: { xs: '100dvh', sm: '85dvh' },
          alignSelf: 'center',
          mb: { xs: 0, sm: 2 },
        },
      }}
    >
      <DialogTitle sx={{ pb: 0, pr: 6, pt: { xs: 0, sm: 2 } }}>
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', right: 12, top: 12, color: 'text.secondary' }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          pt: { xs: 0.5, sm: 2 },
          pb: { xs: 0.5, sm: 1.5 },
          px: { xs: 1, sm: 3 },
          overflowY: 'auto',
          WebkitOverflowScrolling: 'touch',
          scrollbarWidth: 'thin',
          scrollbarColor: `${alpha('#D4AF37', 0.3)} transparent`,
          '&::-webkit-scrollbar': {
            width: 3,
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: alpha('#D4AF37', 0.3),
            borderRadius: 2,
            transition: 'background-color 0.3s ease',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: alpha('#D4AF37', 0.6),
          },
        }}
      >
        <InquiryForm onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
};

export default InquiryPopup;
